/* eslint-disable react/jsx-one-expression-per-line */
import Divider from "@mui/material/Divider/Divider";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop/Backdrop";
import { CircularProgress } from "@mui/material";
import Title from "../../components/Title";
import InfoText from "./components/InfoText";
import styles from "./ActivatedPage.module.css";
import ActivationInfoCard from "./components/ActivationInfoCard";
import AppInfoCard from "./components/AppInfoCard";
import MobileAppInfoCard from "./components/MobileAppInfoCard";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { customTheme } from "../../util/constants";
import API from "../../api/API";
import ErrorPage from "../ErrorPage/ErrorPage";

let hasFetched = false;

const ActivatedPage = () => {
  const { width } = useWindowDimensions();
  const [searchParams] = useSearchParams();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (hasFetched) return;
    hasFetched = true;

    const phoneNumberEncrypted = searchParams.get("pn");
    const emailEncrypted = searchParams.get("email");

    if (!phoneNumberEncrypted || !emailEncrypted) {
      setErrorMessage("Missing URL parameters");
      return;
    }

    API.post("devices/activation/activated", {
      phoneNumber: phoneNumberEncrypted,
      email: emailEncrypted,
    })
      .then((response) => {
        setPhoneNumber(response.data.phone);
        setEmail(response.data.email);
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          setErrorMessage("Missing phone details in session");
          console.error("Error calling `devices/activated` api; Missing phone details in session", error, {
            message: "Missing phone details in session",
            file: "activatedPage.tsx",
            timeStamp: new Date().toISOString(),
          });
        } else {
          setErrorMessage("Unknown Error");
          console.error("Error calling `devices/activated` api", error, {
            file: "activatedPage.tsx",
            timeStamp: new Date().toISOString(),
          });
        }
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return errorMessage ? (
    <ErrorPage message={errorMessage} />
  ) : (
    <>
      <div className={`${styles.upper_page} ${width < customTheme.breakpoints.values.md ? styles.mobile : ""}`}>
        <Title color="white">
          Your watch <Divider sx={{ display: { xs: "", sm: "none" }, visibility: "hidden" }} />
          is activated! 🎉
        </Title>
        <InfoText />
        {/* <RestartInfoCard /> */}
        <ActivationInfoCard email={email} phoneNumber={phoneNumber} />
        <MobileAppInfoCard />
      </div>
      <div className={styles.lower_page}>
        <AppInfoCard />
      </div>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} onClick={() => {}}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ActivatedPage;
